import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/shadcn/card";

export function WelcomePage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-full w-full p-6">
      <div className="max-w-2xl w-full">
        <Card className="shadow-[var(--shadow-depth-md)]">
          <CardHeader>
            <CardTitle className="text-3xl font-bold text-black-1 mb-2">
              Welcome to Rentinit Admin
            </CardTitle>
            <CardDescription className="text-lg text-gray-1">
              Administrative dashboard for managing property rentals across the
              GCC
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <p className="text-md text-foreground">
                You're now logged into the administrative dashboard. From here,
                you can manage properties, users, and system settings.
              </p>
              <div className="pt-4 border-t border-gray-3">
                <p className="text-sm text-muted-foreground">
                  Use the navigation menu to access different sections of the
                  admin panel.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
